<script setup lang=ts>
import { ref } from 'vue';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';
import InfiniteMarquee from '@/home/components/InfiniteMarquee.vue';

const { $fetch } = useFetch();

const { data } = useAsyncData(
  'home:information:pinnded',
  () => $fetch('/information/v2/home_info_list', { method: 'post', data: { isSelected: 1, pageSize: 10 } }),
);
const marqueeSpeed = ref(0);

function updateMarqueeHeight(height: number) {
  marqueeSpeed.value = height > 480 ? 5 : 0;
}
</script>

<template>
  <section class="relative w-288 rounded-6 bg-[#fff] pb-36 pt-110 shadow-[0_1px_6px_0_rgba(0,0,0,0.04)] before:pointer-events-none before:absolute before:left-0 before:top-0 before:z-20 before:h-198 before:w-full before:bg-[linear-gradient(180deg,_rgba(0,154,255,0.09)_0%,_rgba(122,192,253,0)_100%)] before:content-empty">
    <img src="@/home/assets/home/pinned.png" class="absolute left-20 top-26 block h-40 w-96" alt="">
    <img src="@/home/assets/home/info-logo.png" class="absolute left-128 top--16 z-100 block w-70" alt="">

    <div class="relative h-full overflow-hidden after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:z-10 after:h-24 after:w-full after:bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,#fff_100%)] after:content-empty before:pointer-events-none before:absolute before:left-0 before:top-0 before:z-10 before:h-24 before:w-full before:bg-[linear-gradient(180deg,#fff_0%,rgba(255,255,255,0)_100%)] before:content-empty">
      <InfiniteMarquee :speed="marqueeSpeed" @change-height="updateMarqueeHeight">
        <div class="mb-24 px-24 first-of-type:mt-12" v-for="item in data" :key="item.informationId">
          <RouterLink :to="`/explore/journalism/detail/${item.informationId}`" target="_blank" class="group">
            <h3 class="line-clamp-2">
              <span class="mr-8 inline-block h-22 rounded-4 bg-[#feefde] px-6 text-12 text-[#FC8B06] font-400 leading-24">{{ $t('home.home.template3.prime') }}</span>
              <span class="break-anywhere text-16 text-[#292929] font-500 leading-24 group-hover:underline" :title="item.informationTitle">{{ item.informationTitle }}</span>
            </h3>
          </RouterLink>
          <p class="line-clamp-2 mt-8 break-anywhere text-14 text-[#575757] font-400 leading-22">{{ item.informationMsg }}</p>
        </div>
      </InfiniteMarquee>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
